import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.108 6.772h3.6v.96h-3.6v3.6h-.96v-3.6h-3.6v-.96h3.6v-3.6h.96v3.6zM7.5 15a7.5 7.5 0 110-15 7.5 7.5 0 010 15zm0-1a6.5 6.5 0 100-13 6.5 6.5 0 000 13z" fill="#4285F4" fillRule="nonzero" /></svg>);